export default "__VITE_ASSET__e94105ad__"